import React from 'react';

interface Props {
    className?: string;
}
class Spinner extends React.Component<Props> {
    render(): JSX.Element {
        return (
            <div className={`{spinner spinner-border spinner-border-sm main-blue-color ${this.props.className || ''}`} >
                <span className="sr-only">Loading...</span>
            </div >
        );
    }
}

export default Spinner;